import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useNavigate, useLocation } from 'react-router-dom'
import Navbar from './Components/Navigation/index';
//UCI SECTION
import Dashboard from './Components/Dashboard/index';
import CreateTeam from './Components/CreateTeam/index';
import EditTeam from './Components/EditTeam/index';
import Events from './Components/Events/index';
import Leagues from './Components/Leagues/index';
import League from './Components/League/index';

//RAMPAGE SECTION
import RampageDashboard from './Components/RampageComponents/Dashboard';
import RampageLeague from './Components/RampageComponents/League';
import RampageLeagues from './Components/RampageComponents/Leagues';
import RampageAdmin from './Components/RampageComponents/Admin';
import RampageEditTeam from './Components/RampageComponents/EditTeam';

//OTHER SECTION
import Login from './Components/Login/index';
import Admin from './Components/Admin/index';
import Footer from './Components/Footer/index';
import ResetPassword from './Components/ResetPassword';
import Contact from './Components/Contact'
import Profile from './Components/Profile'
import Button from 'react-bootstrap/Button'
import background from './Components/2023 - 1 of 1 (1).jpeg'
import { GoogleOAuthProvider } from '@react-oauth/google';
import Cookies from 'universal-cookie'
import jwtDecode from 'jwt-decode'
import ReactGA from 'react-ga4';

import './Components/main.css'
import './custom-bootstrap.scss';
import Banner_Ad_Mobile from './Images/DMR/Banner_Ad_Mobile.jpg'
import Banner_Ad_NonMobile from './Images/DMR/BannerAd_NonMobile_2.png'
import { AddUserToLeague, SyncLeaderboard } from './ApiRampageRequests';
// import Banner_Ad_NonMobile from './Images/DMR/Banner_Ad_NonMobile.jpg'


const App = () => {
  // const [isLoggedIn, setIsLoggedIn] = useState(false);
  const cookies = new Cookies();
  const location = useLocation()

  const [isLoggedIn, setIsLoggedIn] = useState(true)
  const [isAdmin, setIsAdmin] = useState(false)
  const [pathname, setPathname] = useState('')
  const [params, setParams] = useState('')

  const userName = localStorage.getItem('userName') ? localStorage.getItem('userName') : null
  const navigate = useNavigate()
  const GLOBAL_LEAGUEID = '6504ab5ed4cb5b56c139b861'

  const TRACKING_ID = 'G-79JTMJV3B6'
  ReactGA.initialize(TRACKING_ID);


  const JoinGlobalLeague = async () => {
    const userId = localStorage.getItem("userID")
    const res = await AddUserToLeague(userId, GLOBAL_LEAGUEID)
  }

  const JoinLeague = async (leagueId) => {
    const userId = localStorage.getItem("userID")
    const res = await AddUserToLeague(userId, leagueId)
  }
  const handleLogin = async (_user, leagueId, leagueType) => {

    if (!_user) {
      console.log("no user found")
      setIsLoggedIn(true);
      navigate('/')
      return
    }

    if (leagueId !== null) {

      if (leagueType == 'rampage') {
        if (!_user.rampageTeam) {
          await JoinGlobalLeague();

          if (leagueId != GLOBAL_LEAGUEID) {
            JoinLeague(leagueId)
          }
          SyncLeaderboard()

          navigate(`/rampage/EditTeam?leagueId=${leagueId}`)
          setIsLoggedIn(true);
          return
        }

        const _team = _user.rampageTeam;
        if (_team) {
          navigate(`/rampage/League?leagueId=${leagueId}`)
          setIsLoggedIn(true);
          return
        }
      } else {
        if (!'teams' in _user) {
          navigate(`/CreateTeam?leagueId=${leagueId}`)
          setIsLoggedIn(true);
          return
        }

        const _team = _user.teams.find((team) => team.leagueId == leagueId)
        if (_team) {
          navigate(`/League?leagueId=${leagueId}`)
          setIsLoggedIn(true);
          return
        } else {
          navigate(`/CreateTeam?leagueId=${leagueId}`)
          setIsLoggedIn(true);
          return
        }
      }
    }


    setIsLoggedIn(true);
    if (pathname == '' && params == '') {
      navigate('/')
      return
    }

    navigate(`${pathname}${params}`)
  };


  const handleLogout = () => {
    localStorage.clear()
    setIsLoggedIn(false);
    cookies.remove('jwt')

    if (window.location.pathname != '/reset-password' && window.location.pathname != '/Login' && window.location.pathname != '/contact') {
      setPathname(window.location.pathname)
      setParams(location.search)
      navigate('/Login' + location.search)
    }
  };

  useEffect(() => {
    const jwt = cookies.get('jwt');

    if (!jwt) {
      handleLogout()
      return;
    }

    const decodedToken = jwtDecode(jwt)
    const expirationTime = decodedToken.exp * 1000;

    if (Date.now() >= expirationTime) {
      if (isLoggedIn) {
        handleLogout()
      }
    } else {

      const params = new URLSearchParams(location.search);
      const leagueId = params.get('leagueId')
      if (!leagueId && window.location.pathname == '/Login') {
        navigate('/')
      }
    }

  }, []);

  useEffect(() => {

    const currentPathname = location.pathname;
    const isRampage = currentPathname.toLowerCase().includes('rampage');
    document.body.className = isRampage ? 'rampage-body' : '';

    return () => {
      document.body.className = '';
    };
  }, [location.pathname]);



  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <div className='App main-div' style={{ height: '100%' }}>
        {location.pathname.toLowerCase().includes('rampage') &&
          <div className="banner-ad">
            <a href='https://www.dmrbikes.com'>
              <img
                className="mobile-image hidden-on-desktop"
                src={Banner_Ad_Mobile}
                alt="Desktop Ad"
              />
              <img
                className="desktop-image hidden-on-mobile"
                src={Banner_Ad_NonMobile}
                alt="Mobile Ad"
              />
            </a>
          </div>
        }

        <Navbar isLoggedIn={isLoggedIn} userName={userName} handleLogout={handleLogout} handleLogin={handleLogin} />
        <Routes>
          {/* UCI ROUTES */}
          <Route path="/" element={isLoggedIn ? <Dashboard /> : <Navigate to="/Login" />}></Route>
          <Route exact path="/CreateTeam" element={isLoggedIn ? <CreateTeam /> : <Navigate to="/Login" />}></Route>
          <Route exact path="/EditTeam" element={isLoggedIn ? <EditTeam /> : <Navigate to="/Login" />}></Route>
          <Route exact path="/Events" element={isLoggedIn ? <Events /> : <Navigate to="/Login" />}></Route>
          <Route path="/Login" element={<Login handleLogin={handleLogin} />}></Route>
          <Route exact path="/Leagues" element={isLoggedIn ? <Leagues /> : <Navigate to="/Login" />}></Route>
          <Route exact path="/League" element={isLoggedIn ? <League /> : <Navigate to="/Login" />}></Route>
          <Route exact path="/Admin" element={isLoggedIn ? <Admin /> : <Navigate to="/Login" />}></Route>
          <Route exact path="/reset-password" element={<ResetPassword></ResetPassword>}></Route>

          {/* RAMPAGE ROUTES */}
          <Route path="/rampage/" element={isLoggedIn ? <RampageDashboard /> : <Navigate to="/Login" />}></Route>
          <Route exact path="/rampage/League" element={isLoggedIn ? <RampageLeague /> : <Navigate to="/Login" />}></Route>
          <Route exact path="/rampage/Leagues" element={isLoggedIn ? <RampageLeagues /> : <Navigate to="/Login" />}></Route>
          <Route exact path="/rampage/Admin" element={isLoggedIn ? <RampageAdmin /> : <Navigate to="/Login" />}></Route>
          <Route exact path="/rampage/EditTeam" element={isLoggedIn ? <RampageEditTeam /> : <Navigate to="/Login" />}></Route>

          {/* OTHER ROUTES */}
          <Route path="/contact" element={<Contact></Contact>}></Route>
          <Route path="/Profile" element={<Profile></Profile>}></Route>
        </Routes>
        <Footer />
      </div>
    </GoogleOAuthProvider>

  );
};

export default App;
